// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dOHxP","name":"styles_name__JO8ko","phone":"styles_phone__2yLcn"};